import { Helper } from '../Helper';
export class MergeAssetValueMapsHelper extends Helper {
    constructor({ add }) {
        super();
        this.add = add;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.arrReduce({
            each: () => {
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitSysCall(node, 'Neo.Output.GetScriptHash');
                sb.emitSysCall(node, 'System.ExecutionEngine.GetExecutingScriptHash');
                sb.emitHelper(node, options, sb.helpers.if({
                    condition: () => {
                        sb.emitOp(node, 'EQUAL');
                    },
                    whenTrue: () => {
                        sb.emitOp(node, 'OVER');
                        sb.emitOp(node, 'OVER');
                        sb.emitOp(node, 'SWAP');
                        sb.emitSysCall(node, 'Neo.Output.GetAssetId');
                        sb.emitOp(node, 'TUCK');
                        sb.emitHelper(node, options, sb.helpers.if({
                            condition: () => {
                                sb.emitOp(node, 'HASKEY');
                            },
                            whenTrue: () => {
                                sb.emitOp(node, 'TUCK');
                                sb.emitOp(node, 'PICKITEM');
                                sb.emitOp(node, 'ROT');
                                sb.emitSysCall(node, 'Neo.Output.GetValue');
                                if (this.add) {
                                    sb.emitOp(node, 'ADD');
                                }
                                else {
                                    sb.emitOp(node, 'SUB');
                                }
                                sb.emitOp(node, 'SETITEM');
                            },
                            whenFalse: () => {
                                sb.emitOp(node, 'ROT');
                                sb.emitSysCall(node, 'Neo.Output.GetValue');
                                if (!this.add) {
                                    sb.emitOp(node, 'NEGATE');
                                }
                                sb.emitOp(node, 'SETITEM');
                                sb.emitOp(node, 'DROP');
                            },
                        }));
                    },
                    whenFalse: () => {
                        sb.emitOp(node, 'DROP');
                        sb.emitOp(node, 'DROP');
                        sb.emitOp(node, 'DROP');
                    },
                }));
            },
        }));
        if (!optionsIn.pushValue) {
            sb.emitOp(node, 'DROP');
        }
    }
}

//# sourceMappingURL=MergeAssetValueMapsHelper.js.map
